import React from 'react';
import {
  Box,
  Typography,
  IconButton,
  Divider,
  ListItem,
  ListItemText,
} from '@mui/material';
import { ContentCopyOutlined, FileDownloadOutlined } from '@mui/icons-material';
import { PetParentAnimal } from '../../../types/PetParent';
import { track } from '../analytics';

interface PetRecordsSectionProps {
  animal: PetParentAnimal;
  onCopyMicrochip: () => void;
  medicalRecordUrl?: string;
}

function PetRecordsSection({ animal, onCopyMicrochip, medicalRecordUrl }: PetRecordsSectionProps) {
  const hasMicrochip = Boolean(animal.microchipNumber);
  const hasMedicalRecords = Boolean(medicalRecordUrl);

  if (!hasMicrochip && !hasMedicalRecords) {
    return null;
  }

  return (
    <Box
      sx={{
        bgcolor: 'white',
        borderRadius: '12px',
        boxShadow: '0px 0px 8px 0px rgba(0, 0, 0, 0.08)',
        p: 1.5,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Box sx={{ px: 2, py: 1.5, minHeight: '48px' }}>
        <Typography
          variant="h6"
          sx={{ color: 'rgba(0, 0, 0, 0.87)' }}
        >
          Records
        </Typography>
      </Box>

      {hasMicrochip && (
        <>
          <Box sx={{
            px: 2, py: 1.5, display: 'flex', alignItems: 'center',
          }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                variant="body2"
                sx={{
                  fontSize: '12px',
                  color: 'rgba(0, 0, 0, 0.6)',
                  mb: 0.75,
                  lineHeight: '12px',
                }}
              >
                Microchip number
              </Typography>
              <Typography variant="body1" sx={{ color: 'rgba(0, 0, 0, 0.87)' }}>
                {animal.microchipNumber}
              </Typography>
            </Box>
            <IconButton
              size="small"
              onClick={onCopyMicrochip}
              sx={{ mr: '-4px' }}
            >
              <ContentCopyOutlined fontSize="small" />
            </IconButton>
          </Box>
          {hasMedicalRecords && <Divider sx={{ borderColor: 'rgba(238, 238, 238, 1)' }} />}
        </>
      )}

      {hasMedicalRecords && (
        <ListItem
          onClick={() => {
            track('medical_record_view_click');
            window.open(medicalRecordUrl, '_blank');
          }}
          sx={{ px: 2, py: 0.5 }}
        >
          <ListItemText
            primary="Medical records"
            primaryTypographyProps={{
              variant: 'body1',
              sx: { color: 'rgba(0, 0, 0, 0.87)' },
            }}
            sx={{ py: 0.5 }}
          />
          <IconButton size="small" sx={{ mr: '-4px' }}>
            <FileDownloadOutlined fontSize="small" />
          </IconButton>
        </ListItem>
      )}
    </Box>
  );
}

export default PetRecordsSection;
